module.exports = __webpack_public_path__ + "img/simple-simulation.1fb9a52a.svg";